export const COUNTRY_DATA: Record<string, {
  country_key: string;
  code: string;
  name: string;
  flag: string;
  pattern: RegExp;
  length: number;
  messageKey: string;
  timeZone: string;
}> = {
  in: {
    country_key: "in",
    code: "+91",
    name: "India",
    flag: "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png",
    pattern: /^[6-9]\d{9}$/,
    length: 10,
    messageKey: "countryValidation.india",
    timeZone: "Asia/Kolkata"
  },
  id: {
    country_key: "id",
    code: "+62",
    name: "Indonesia",
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Indonesia.svg/1200px-Flag_of_Indonesia.svg.png",
    pattern: /^[8]\d{8,11}$/,
    length: 12,
    messageKey: "countryValidation.indonesia",
    timeZone: "Asia/Jakarta"
  },
  vn: {
    country_key: "vn",
    code: "+84",
    name: "Vietnam",
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Vietnam.svg/1200px-Flag_of_Vietnam.svg.png",
    pattern: /^[3-9]\d{8}$/,
    length: 9,
    messageKey: "countryValidation.vietnam",
    timeZone: "Asia/Ho_Chi_Minh"
  },
  // bd: {
  //   country_key: "bd",
  //   code: "+880",
  //   name: "Bangladesh",
  //   flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Flag_of_Bangladesh.svg/1200px-Flag_of_Bangladesh.svg.png",
  //   pattern: /^[1-9]\d{9}$/,
  //   length: 10,
  //   messageKey: "countryValidation.bangladesh",
  //   timeZone: "Asia/Dhaka"
  // },
  th: {
    country_key: "th",
    code: "+66",
    name: "Thailand",
    flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/1200px-Flag_of_Thailand.svg.png",
    pattern: /^[6-9]\d{8}$/,
    length: 9,
    messageKey: "countryValidation.thailand",
    timeZone: "Asia/Bangkok"
  },
  // lk: {
  //   country_key: "lk",
  //   code: "+94",
  //   name: "Sri Lanka",
  //   flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Flag_of_Sri_Lanka.svg/1200px-Flag_of_Sri_Lanka.svg.png",
  //   pattern: /^[7]\d{8}$/,
  //   length: 9,
  //   messageKey: "countryValidation.sriLanka",
  //   timeZone: "Asia/Colombo"
  // },
  // my: {
  //   country_key: "my",
  //   code: "+60",
  //   name: "Malaysia",
  //   flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Malaysia.svg/1200px-Flag_of_Malaysia.svg.png",
  //   pattern: /^[1]\d{8,9}$/,
  //   length: 9,
  //   messageKey: "countryValidation.malaysia",
  //   timeZone: "Asia/Kuala_Lumpur"
  // }
};

export function getCountryFromPath(pathname: string) {
  const match = pathname.match(/^\/([a-z]{2,})/i);
  if (!match) return null;
  const pathCode = match[1].toLowerCase();
  return COUNTRY_DATA[pathCode] || null;
}
